export const BOOKING_ORIGIN: string = import.meta.env.VITE_BOOKING_ORIGIN ?? 'https://book.harmovi.com'

export function bookingLink(slug: string): string {
  return `${BOOKING_ORIGIN}/${encodeURIComponent(slug)}`
}
